import { Link } from 'react-router-dom';

export default function ReadingCTA() {
  return (
    <section className="relative w-full h-[420px] md:h-[520px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20reading%20scene%20illustration%20with%20warm%20cozy%20indoor%20lighting%2C%20minimalist%20composition%2C%20soft%20evening%20atmosphere%2C%20warm%20amber%20and%20coral%20tones%2C%20comfortable%20reading%20nook%20with%20gentle%20light%2C%20Korean%20webtoon%20aesthetic%20background%2C%20inviting%20and%20calm%20mood&width=1920&height=800&seq=cta-bg-reading&orientation=landscape"
        alt="下拉式阅读体验"
        title="韩漫免费漫画在线观看下拉式"
        className="w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/25 to-black/55"></div>

      <div className="absolute inset-0 flex items-center justify-center">
        <div className="w-full px-4 md:px-6 text-center max-w-3xl mx-auto">
          <h2 className="font-heading text-2xl md:text-4xl text-white mb-3">
            沉浸式
            <strong className="font-heading text-accent-400">下拉式阅读</strong>
            体验
          </h2>
          <p className="text-sm md:text-base text-white/75 mb-8 leading-relaxed">
            告别繁琐的翻页操作，只需向下滑动即可连续阅读。
            专为移动端优化的下拉式阅读，让韩漫观看更加流畅自然。
          </p>
          <Link
            to="/category/romance"
            className="inline-flex items-center gap-2 px-8 py-3 bg-foreground-950 text-white rounded-full text-sm font-medium hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer"
          >
            <div className="w-5 h-5 rounded-full bg-accent-500 flex items-center justify-center">
              <div className="w-3 h-3 flex items-center justify-center">
                <i className="ri-book-open-line text-white text-xs"></i>
              </div>
            </div>
            开始阅读
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-up-line text-sm"></i>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
}